import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useSelectablePaymentTerms } from "../../../common/hooks/useSelectableItemQueries.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { ContractModel } from "../Contract.types.ts";

export interface PaymentTermsFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    /** Suppresses the field's help icon, for a view where the same field is shown twice. */
    hideToolTip?: boolean;
    isLoading: boolean;
    paymentTermId: string | undefined;
    readOnly: boolean;
    onChange: (changeFunc: (contract: ContractModel) => void) => Promise<void>;
    isDisabled: boolean;
    required: boolean;
    isPreview: boolean;
    errorText?: string;
}

function PaymentTermsField(props: PaymentTermsFieldProps) {
    const { translateString } = useTranslation();
    const paymentQuery = useSelectablePaymentTerms(!props.isPreview);

    return (
        <DotLegalSelect
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            options={paymentQuery.data}
            isLoading={props.isLoading || paymentQuery.isLoading}
            onChange={
                props.readOnly
                    ? () => {}
                    : (value) =>
                          props.onChange((c) => {
                              c.paymentTermId = value ? value : undefined;
                          })
            }
            label={translateString("paymentTerms")}
            selectedItem={props.paymentTermId}
            disabled={props.isDisabled}
            disableClearable={props.required}
            noOptionsLabel={translateString("noOptions")}
            toolTipText={props.hideToolTip ? undefined : translateString("contractPaymentTermsTooltip")}
            errorText={props.errorText}
        />
    );
}

export default PaymentTermsField;
